import Vue from "vue";
import ResourceService from "./resource.service";
class VehicleService extends ResourceService {
  static get resource() {
    return "vehicle";
  }

  static assign(slug, data) {
    const url = `${this.resource}/${slug}`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static ratingDetails(vehicleID, rateNumber, params = {}) {
    const url = `${this.resource}/${vehicleID}/rating-details/${rateNumber}`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static rating(vehicleID) {
    const url = `${this.resource}/${vehicleID}/rating`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static download(params) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/download`, {
          responseType: "blob",
          params
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

   static upload(formData) {
      const url = `${this.resource}/import-vehicles`;
      return new Promise((resolve, reject) => {
        Vue.axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(({ data }) => resolve(data))
          .catch((error) => reject(error));
      });
    }
}

export default VehicleService;
